<template>
  <!--购物车页面-->
  <tk-container
    :status="status"
    :probeType="3"
    @scroll="watchScroll"
    infiniteScroll
    hide-status-bar
    ref="resetPaySuccess"
    @refresh="refreshInit"
    @loadingMore="recommendedProducts"
  >
    <!--头部-->
    <gradient-header slot="header" :is-show-back="true" :is-header-color="isHeaderColor" :back-style="false" :icon-name="'return'"></gradient-header>
    <!--背景图片渲染-->
    <div
      class="content-box"
      :style="`background-image: url('https://s3.moke.cloud/dianpei/8a4dc658-c704-44e7-a2f6-6e7df8c6cd12.png') !important`"
    >
      <tk-flex column center middle>
        <tk-flex middle center class="full-width">
          <tk-icon size="26" color="#fff">duihao</tk-icon>
          <span style="line-height: 1;font-size: 22px;" class="primary-white m-l-5 font-bold">支付成功</span>
        </tk-flex>
        <tk-flex
          center
          bottom
          middle
          class="primary-white font-18 m-t-12 full-width"
          style="color: #FFE593;line-height: 1;">实付 <span class="font-10 m-l-5 m-t-4">￥</span>
          <span style="font-size: 19px !important;">{{orderAmount}}</span>
        </tk-flex>
        <tk-flex gutter="30" center class="m-t-24 full-width">
          <tkui-button class="border small rounded success-btn" @click="nextHome">返回首页</tkui-button>
          <tkui-button class="border small rounded success-btn"
                       @click="$push({path: '/common/orderDetail',
                        query: { id: $route.query.id, type: 'myOrder' }})"
                       shadow>查看订单</tkui-button>
        </tk-flex>
      </tk-flex>
      <div class="m-x-12 m-t-20">
        <tk-card is-center :height="68" :width="100" is-middle>
          <tk-flex
            style="font-size: 17px;"
            center middle
            class="font-bold"
          >
            <tk-image :src="'https://s3.moke.cloud/dianpei/ea671093-e798-491f-8c91-d60be5e5a818.png'" height="13" width="16"></tk-image>
            <div class="p-x-4" :style="{color: '#000000'}">为你推荐</div>
            <tk-image :src="'https://s3.moke.cloud/dianpei/2fb0e425-8126-46f2-93a0-ff227804ea21.png'" height="13" width="16"></tk-image>
          </tk-flex>
        </tk-card>
      </div>
    </div>
    <!--为你推荐-->
    <infinite-list :title="'为你推荐'" :infinite-list-pad="'p-x-12'" :is-title="false" :products-data="getPriceProcessing(recommendedProductsData, judgeTimeRule)" :color="'#000000'"></infinite-list>
  </tk-container>
</template>

<script>
import { priceProcessing } from '@/assets/help/tool'
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      isHeaderColor: false, // 判断头部颜色切换
      timeRule: null, // 限时抢购时间
      orderDetail: null, // 订单详情
      recommendedProductsData: [] // 猜你喜欢商品数据获取
    }
  },
  computed: {
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    },
    // 订单实付金额
    orderAmount () {
      if (!this.orderDetail) { return 0 }
      if (!this.orderDetail.orderAmount) { return 0 }
      return this.orderDetail.orderAmount
    }
  },
  activated () {
    this.setStatusBar('light')
    if (this.isHeaderColor) {
      this.setStatusBar('dark')
    }
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
     * 初始化数据
     * @date: 2020/4/1
     */
    async getInit () {
      try {
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        await this.getOrderDetail() // 获取订单信息
        // 根据订单id获取订单实付金额
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.recommendedProductsData = []
      await this.getInit()
      this.$refs.resetPaySuccess.resetInfiniteScroll()
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/3/20
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let timeRule = await this.$tkParse.getList(`/classes/timeRule`, {
        params: {
          limit: 1,
          where: {
            startTime: {
              $lte: {
                '__type': 'Date',
                'iso': isoStartDate
              }
            }
          }
        }
      })
      if (timeRule.length) { this.timeRule = timeRule[0] } else { this.timeRule = null }
    },
    /**
    * 获取订单详细信息
    * @date: 2020/4/30
    */
    async getOrderDetail () {
      this.orderDetail = await this.$tkParse.getData(`/classes/order/${this.$route.query.id}`)
    },
    /**
     * 为你推荐数据获取
     * @date: 2020/4/1
     */
    async recommendedProducts (page, next) {
      let commodityData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          // order: '-updatedAt',
          order: 'weight',
          where: {
            category: {
              $inQuery: {
                where: {
                  objectId: {
                    $ne: '80dkpxb8rC'
                  }
                },
                className: 'secondaryClassification'
              }
            },
            shelvesStatus: 'shelves'
          }
        }
      })
      this.recommendedProductsData = [...this.recommendedProductsData, ...commodityData]
      if (commodityData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
    * 跳转首页
    * @date: 2020/4/29
    */
    nextHome () {
      this.$cleanHistory()
      this.$replace('/')
    }
  }
}
</script>

<style scoped lang="scss">
  /*后台数据渲染样式*/
  .content-box {
    /*background-position: center center;*/
    padding-top: 60px;
    background-repeat:  no-repeat;
    background-size: 100% auto;
    min-height: 300px;
  }
  .success-btn {
    min-width: 115px;
    color: #f5f5f5 !important;
    border: 1px solid #f5f5f5;
  }
</style>
